import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_ITEM } from '../../../../../../../../webcomponents.constants';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { GzInputNumberWebComponent } from '../../../../../../../../ui/gzInput';
import { FormGroup } from 'apps/webcomponents/src/ui/gzForm/formGroup/form-group';
import { RequiredValidator } from 'apps/webcomponents/src/ui/gzForm/validators/required.validator';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { MinValidator } from '../../../../../../../../ui/gzForm/validators/min.validator';
import { MaxValidator } from '../../../../../../../../ui/gzForm/validators/max.validator';
import { HostnameValidator } from '../../../../../../../../ui/gzForm/validators/hostname.validator';

const CONFIDENCE_LEVEL_MAX_PERCENT = 100;
const CONFIDENCE_LEVEL_MIN_PERCENT = 1;

@customElement(WEB_COMPONENT_EXCHANGE_ANTISPAM_SETTINGS_ITEM)
export class GzExchangeAntispamSettingsItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#server-form')
  serverForm: GzFormFieldWebComponent<GzInputWebComponent, string>;
  @query('#confidence-form')
  confidenceForm: GzFormFieldWebComponent<GzInputNumberWebComponent, number | undefined>;
  protected createFormGroup(): void {
    this.serverForm.Validators = [
      RequiredValidator(translateFn('RBL server address is required.')),
      HostnameValidator(translateFn('Invalid RBL server address')),
    ];
    this.confidenceForm.Validators = [RequiredValidator(translateFn('Confidence level is required.'))];

    this.formGroup = new FormGroup({
      server: this.serverForm,
      confidenceLevel: this.confidenceForm,
    });
  }

  protected renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field" style="flex-grow: 2">
        <gz-form-field id="server-form"
          ><gz-input gz-form-input label="${translateFn('RBL server')}"></gz-input
        ></gz-form-field>
      </div>
      <div class="policy-grid-item-form--field ">
        <gz-form-field id="confidence-form"
          ><gz-input-number
            min="${CONFIDENCE_LEVEL_MIN_PERCENT}"
            max="${CONFIDENCE_LEVEL_MAX_PERCENT}"
            inputWidth="160"
            gz-form-input
            label="${translateFn('Confidence level ({percent})', { percent: '%' })}"
          ></gz-input-number
        ></gz-form-field>
      </div>
    `;
  }

  resetForm(resetType = true): void {
    this.serverForm.value = '';
    this.serverForm.resetField();
    this.confidenceForm.value = undefined;
    this.confidenceForm.resetField();
  }

  reset(): void {
    this.resetForm();
  }

  resetOnAdd(): void {
    this.resetForm();
  }
}
